import styled from '@emotion/styled';

export const PanelTitle = styled.h4({
  display: 'flex',
  alignItems: 'center',
  height: '20px',
  fontSize: '14px',
  fontWeight: 500,
  color: 'var(--fett-text-primary)',
});

export const PackTip = styled.span({
  fontWeight: 400,
  fontSize: '12px',
  color: 'var(--fett-surface-warning-text)',
});

export const List = styled.ul({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '16px',
  listStyle: 'none',
  padding: 0,
  margin: 0,
});

export const ListItem = styled.li({
  flexBasis: 278,
  flexGrow: 0,
  flexShrink: 1,
  position: 'relative',
  height: '100%',
});
